module.exports = {
    "crude": {
        "search": "Keress",
        "actions": "Akciók",
        "nextPage": "Következő oldal",
        "lastPage": "Előző oldal",
        "back": "Vissza",
        "empty": "üres",
        "edit": "szerkeszteni",
        "create": "teremt",
        "data": "rekord",
        "view": "előadás",
        "delete": "Töröl",
        "save": "Megment",
        "cancel": "Megszünteti",
        "noContent": "Nincs elérhető bejegyzés. ",
        "resetFilter": "Állítsa vissza a szűrőket, és tekintsen meg több tartalmat!",
        "createOwnTextField": "Hozzon létre saját szövegmezőt",
        "textFieldName": "szövegmező címke",
        "textFieldValue": "Tartalom",
        "insertTextFieldLabel": "Kérjük, írja be a szövegmező nevét!",
        "deleteTextField": "Szövegmező törlése",
        "success": "A mentés sikeres volt",
        "invalidDataFields": "A következő adatmezők érvénytelenek:  ",
        "entries": "bejegyzés",
        "entry": "belépés",
        "tabDetail": "részletek",
        "entity": "entitás",
        "of": "tól től",
        "uploadNewFile": "Fájl feltöltés",
        "upload": "feltölteni",
        "confirm": "rendben",
        "deleteFileQuestion": "Biztosan törölni szeretné ezt a fájlt? ",
        "deleteFileQuestionTitle": "Veszély!",
        "deleteEntityQuestion": "Biztosan törölni szeretné ezt az entitást? ",
        "deleteEntityQuestionTitle": "Veszély!",
        "errorLargeFileUpload": "A kiválasztott fájl túl nagy!",
        "useCroppedImage": "Használjon termést",
        "useOriginalImage": "Használja az eredeti képet",
        "available": "elérhető",
        "searchColumn": "oszlop keresése",
        "manageColumns": "Oszlopok kezelése",
        "hideColumn": "oszlop elrejtése",
        "pinToRight": "Oszlop rögzítése jobbra",
        "pinToLeft": "Oszlop rögzítése balra",
        "sortAsc": "Növekvő rendezés",
        "sortDesc": "Csökkenő rendezés",
        "hideAll": "mindent elrejteni",
        "showAll": "Mutasd az összeset",
        "preview": "előnézet",
        "title": "cím",
        "description": "Leírás",
        "tooltip": "eszköztipp",
        "sort": "Sorrend",
        "settings": "Beállítások",
        "incomingReference": "referencia",
        "language": "Nyelv",
        "deleteTabQuestionTitle": "Veszély!",
        "deleteTabQuestion": "Biztosan törölni szeretné ezt a lapot? ",
        "deleteElementQuestionTitle": "Veszély!",
        "deleteElementQuestion": "Biztosan törölni szeretné ezt az elemet? ",
        "configurationEditorDescriptionStringLayout": "Ebben az oszlopban három változat választható a szövegbevitelhez:",
        "configurationEditorDescriptionEnumLayout": "Az oszlopban lévő elemek kiválasztásához két változat választható:",
        "configurationEditorDescriptionBooleanLayout": "Az oszlopban lévő elemek kiválasztásához két változat választható:",
        "configurationEditorDescriptionForeignEntityLayout": "Az oszlopban lévő elemek kiválasztásához két változat választható:",
        "stringLayoutsingleline": "egyvonalas",
        "stringLayoutmultiline": "többsoros",
        "stringLayouteditor": "Rich Text Editor",
        "enumLayoutradio": "Rádiógomb",
        "enumLayoutdropdown": "ledob",
        "booleanLayoutcheckbox": "jelölőnégyzetet",
        "booleanLayoutswitch": "kapcsolók",
        "foreignEntityLayoutpopUp": "Felugrik",
        "foreignEntityLayoutautocomplete": "ledob",
        "foreignEntityLayoutlist": "lista",
        "formatTooltipbold": "Zsír",
        "formatTooltipitalic": "dőlt",
        "formatTooltipunderline": "aláhúzva",
        "formatTooltipstrike": "Kihúzott",
        "formatTooltipclean": "tiszta formázás",
        "formatTooltipcodeBlock": "kód",
        "formatTooltipblockquote": "Idézet",
        "formatTooltipcolor": "betű szín",
        "formatTooltipbackground": "háttérszín",
        "formatTooltipfont": "betűtípus",
        "formatTooltipalign": "igazítás",
        "formatTooltipheader": "betűméret",
        "formatTooltipsuper": "Felső index",
        "formatTooltipsub": "alsó index",
        "formatTooltipordered": "Rendezett lista",
        "formatTooltipbullet": "Felsorolás",
        "true": "Igen",
        "false": "nem",
        "selectEntity": "válasszon entitást",
        "filter": "szűrő",
        "useFilter": "Szűrők alkalmazása",
        "defaultFilter": "szűrő visszaállítása",
        "expand": "kiterjed",
        "hide": "elrejt",
        "minimumSelectionError": "Legalább {{min}} bejegyzést kell kiválasztani.",
        "maximumSelectionError": "Legfeljebb {{max}} bejegyzés választható ki."
    }
}
;